import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta';
import { useT } from '../i18n/useT';
import RouteHero from '../components/RouteHero';
import DemoVideo from '../components/DemoVideo';
import TaglineBanner from '../components/TaglineBanner';
import BackToOverview from '../components/BackToOverview';

const DemoPage: React.FC = () => {
  useRouteMeta('demo');
  const { r } = useT();
  return (
    <>
      <RouteHero
        eyebrow={r.routes.demo.eyebrow}
        title={r.routes.demo.heroTitle}
        subtitle={r.routes.demo.heroSubtitle}
      />
      <DemoVideo />
      <TaglineBanner />
      <BackToOverview />
    </>
  );
};

export default DemoPage;
